import { parseAsString, useQueryStates } from 'nuqs';
import type { PlatformAuditRow, PlatformPage } from '@barbeiropro/contracts';
import { Input } from '@/components/ui/input';
import { DataTable, type DataColumn } from '@/components/shared/data-table';
import { PageHeader } from '@/components/shared/page-header';
import { useTableParams } from '@/components/shared/use-table-params';
import { DownloadButton, dt, useList } from './shared';

export function PlatformAuditPage() {
  const params = useTableParams({ sort: 'createdAt', order: 'desc' });
  const [f, setF] = useQueryStates({ action: parseAsString.withDefault(''), from: parseAsString.withDefault(''), to: parseAsString.withDefault('') }, { history: 'replace' });
  const query = { ...params.query, action: f.action || undefined, from: f.from || undefined, to: f.to || undefined };
  const list = useList<PlatformPage<PlatformAuditRow>>('audit', '/platform/audit', query);
  const columns: DataColumn<PlatformAuditRow>[] = [
    { id: 'when', header: 'Quando', meta: { sortKey: 'createdAt' }, cell: ({ row }) => <span className="tabular whitespace-nowrap">{dt(row.original.createdAt)}</span> },
    { id: 'who', header: 'Quem', cell: ({ row }) => row.original.actorName ?? <span className="text-muted-foreground">Sistema</span> },
    { id: 'action', header: 'Ação', meta: { sortKey: 'action' }, cell: ({ row }) => <code className="text-xs">{row.original.action}</code> },
    { id: 'org', header: 'Barbearia', cell: ({ row }) => row.original.organizationName ?? '—' },
    { id: 'entity', header: 'Registro', cell: ({ row }) => row.original.entity },
    {
      id: 'changes',
      header: 'Detalhes',
      cell: ({ row }) => {
        const c = row.original.changes ? JSON.stringify(row.original.changes) : '';
        return c ? <code title={c} className="block max-w-xs truncate text-xs text-muted-foreground">{c}</code> : null;
      },
    },
    { id: 'ip', header: 'IP', cell: ({ row }) => <span className="text-xs text-muted-foreground">{row.original.ip ?? ''}</span> },
  ];
  return (
    <div>
      <PageHeader title="Auditoria" description="Tudo que administradores da plataforma fizeram." actions={<DownloadButton path="/platform/audit/export" query={query} filename="auditoria.xlsx" />} />
      <DataTable
        columns={columns}
        data={list.data}
        params={params}
        isLoading={list.isLoading}
        error={list.error}
        onRetry={list.refetch}
        searchPlaceholder="Buscar por ação, registro ou pessoa"
        empty={{ title: 'Nenhum registro de auditoria' }}
        filters={
          <>
            <Input aria-label="Ação (ex.: org.suspend)" placeholder="Ação (ex.: org.suspend)" value={f.action} onChange={(e) => { void setF({ action: e.target.value }); params.set({ page: 1 }); }} className="h-8 w-48" />
            <Input aria-label="De (AAAA-MM-DD)" placeholder="De (AAAA-MM-DD)" value={f.from} onChange={(e) => { void setF({ from: e.target.value }); params.set({ page: 1 }); }} className="h-8 w-40" />
            <Input aria-label="Até (AAAA-MM-DD)" placeholder="Até (AAAA-MM-DD)" value={f.to} onChange={(e) => { void setF({ to: e.target.value }); params.set({ page: 1 }); }} className="h-8 w-40" />
          </>
        }
      />
    </div>
  );
}
